import React from 'react';
export var themes = ['lightBackground', 'darkBackground'];
export var defaultThemeContext = 'lightBackground';
export var ThemeContext = /*#__PURE__*/React.createContext(defaultThemeContext);